import {useHistory} from '@aboutyou/router';
import {AddToBasketTrackingData} from '@aboutyou/user';

export const useAddToBasketTrackingData = () => {
  const {location} = useHistory();

  const state = location.state as {
    addToBasketTrackingData: AddToBasketTrackingData;
  };

  const addToBasketTrackingData =
    state && 'addToBasketTrackingData' in state
      ? state.addToBasketTrackingData
      : {};

  return addToBasketTrackingData;
};
